import { ApiError, useApiClient, useAsyncCache, useTranslation } from '@msdk/common'
import { EntityModel, FormModel, ListValue, StringValue } from '@msdk/definitions'
import { stringFormat, useEntityFromCollection } from '@msdk/forms'
import { createComponentWrapperWithRef, styled, Typography, uiTokens } from '@msdk/ui'
import React, { useEffect, useState } from 'react'

import { EntityNumericFields } from '../../../ClientCustomLogics'

const StyledDialogTitle = createComponentWrapperWithRef(
  {
    mui: styled('div')`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 7px;
      margin-top: 10px;
    `,
    nova: React.Fragment,
  },
  'StyledDialogTitle',
)
const StyledTypography = createComponentWrapperWithRef<{ children: React.ReactNode }>(
  {
    mui: ({ children }) => <Typography variant="h4"> {children} </Typography>,
    nova: ({ children }) => (
      <Typography variant="body1" color={uiTokens.uiContent.emphasized} fontWeight={uiTokens.font.fontWeight.semiBold}>
        {children}
      </Typography>
    ),
  },
  'StyledTypography',
)

interface Props {
  entityId: string
  formModel: FormModel
  entityModel: EntityModel
}

export function CustomMuHeader(props: Props) {
  const t = useTranslation()
  const cache = useAsyncCache()
  const client = useApiClient()
  const entityContext = useEntityFromCollection(props.entityId as string)

  const [allFieldsFromMetadata, setAllFieldsFromMetadata] = useState<EntityNumericFields[]>([])

  useEffect(() => {
    const fetch = async () => {
      const res = await cache.getOrCreate('MU_NUMERIC_FIELDS_LIST', () =>
        client.read<EntityNumericFields[]>('CMPS/api/composer/basemetadatawithnumerics'),
      )
      if (res instanceof ApiError) {
        return
      }
      setAllFieldsFromMetadata(res)
    }
    fetch()
  }, [])

  const fieldName = (entityContext?.fields?.['MEASUREMENT_UNIT_FIELD_NAME'] as StringValue)?.value
  const entityName = (entityContext?.fields?.['METADATA_LIST'] as ListValue)?.value?.[0]?.fields['ENTITY_NAME']?.value
  const entity = allFieldsFromMetadata.find((i) => i.entity.name === entityName)
  const field = entity?.numericFields?.find((f) => f.name === fieldName)
  const fieldIdml = field?.idml ?? ''
  const fieldDescr = field?.tDescription ?? ''

  return (
    <>
      <StyledDialogTitle>
        <StyledTypography>
          {stringFormat(t('CONVERT_UNIT_OF_MEASURE', 'Convert unit of measure: {0}'), t(fieldIdml, fieldDescr))}
        </StyledTypography>
      </StyledDialogTitle>
    </>
  )
}
